import axios from 'axios'
import { backendUrl } from '../../config/config'

const getLogs = async (query) => {
    const result = await axios.post(`${backendUrl}/api/log/getLogs`, query)
    return result.data;
}

const exportLogs = async () => {
    axios({
        url: backendUrl + '/api/log/export',
        method: 'POST',
        responseType: 'blob', // important
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        const fileName = "export_logs.xlsx";
        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();
      });
  }


export {
    getLogs,
    exportLogs
}